import React from "react";
import { FormikContext } from "formik";
import renderText from "./renderText";

export default function TextNode({ content, context }: any) {
  const formik: any = React.useContext(FormikContext as any);
  const liveContext = {
    ...(context || {}),
    ...(formik || {}),
    values: formik?.values || context?.values,
    errors: formik?.errors || context?.errors,
    touched: formik?.touched || context?.touched,
    status: formik?.status || context?.status,
  };

  return <>{renderText(content, liveContext)}</>;
}
